import { useCookies } from 'react-cookie'
import { useDrag, useDrop } from 'react-dnd'

import { useActionless, useAppSelector } from 'redux/hooks'
import { dropDraggedItem } from 'redux/folders/actions/helpers'
import { SET_FOLDER_STATE } from 'redux/folders/actions/types'
import { DeckCardInfoType } from 'types/search'

import { DropItemTypes } from 'types/draggables'
import { FOLDER_ITEM_TYPES, SubfolderFolderItemType } from 'types/folders'

import ToastService from 'services/toast.service'

export function useFolderDrag(folder: SubfolderFolderItemType, selected: boolean, totalSelected: number) {
  return useDrag(
    () => ({
      type: DropItemTypes.FOLDER,
      item: selected
        ? { type: FOLDER_ITEM_TYPES.MASS, size: totalSelected, data: null }
        : { type: FOLDER_ITEM_TYPES.FOLDER, data: folder, size: 0, name: folder.name },
      canDrag: () => true,
    }),
    [folder, selected, totalSelected],
  )
}

export function useFolderDrop(folder: SubfolderFolderItemType) {
  const [setFolderState] = useActionless(SET_FOLDER_STATE)

  return useDrop(
    () => ({
      accept: DropItemTypes.FOLDER,
      drop: (draggedItem: any) =>
        dropDraggedItem(draggedItem, folder.id).then(setFolderState).catch(ToastService.create),
      canDrop: () => true,
      collect: monitor => ({ isOver: monitor.isOver() }),
    }),
    [folder],
  )
}

export function useDeckDrag(deck: DeckCardInfoType, selected: boolean, totalSelected: number) {
  return useDrag(
    () => ({
      type: DropItemTypes.FOLDER,
      item: selected
        ? { type: FOLDER_ITEM_TYPES.MASS, size: totalSelected, data: null }
        : { type: FOLDER_ITEM_TYPES.DECK, data: deck, size: 0, name: deck.name },
      canDrag: () => true,
    }),
    [deck, selected, totalSelected],
  )
}

export function useIsFolderOwner() {
  const folderOwnerId = useAppSelector(state => state.folders.rootFolder?.owner?.id) || 0
  const [{ tbId: userId }] = useCookies(['tbId'])

  return `${folderOwnerId}` === `${userId}`
}
